import http from '@/http';

const InstituicaoFinanceiraServiceService = {
  async buscarLkpInstituicaoFinanceira(cdCooperado) {
    try {
      const response = await http.get("/api/astec/getLkpInstituicaoFinanc/" + cdCooperado);
      return response.data.map(instituicaoFinanc => ({
        name: instituicaoFinanc.DISPLAY,
        value: instituicaoFinanc.ID,
      }));
    } catch (error) {
      console.log("Erro ao carregar instituicaoFinanceira", error);
      throw error;
    }
  },
};

export default InstituicaoFinanceiraServiceService;
